import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pending-announcement',
  templateUrl: './pending-announcement.component.html',
  styleUrls: ['./pending-announcement.component.sass']
})
export class PendingAnnouncementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
